/* ****************************************************************************
Name:			  Cerfificate upload
**
** Desc:         This code is to manager supplier certificates
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  12/12/2020  Vasu Pabbaraju.           Added logic to validate sublot qty/number from excel = JIRA -- Q360-423
******************************************************************************/ 
import React, {Fragment,useEffect, useState } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withRouter } from "react-router-dom";
import XLSX from 'xlsx';
import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import UploadCreate from './upolad_create_report'
import {
  Col, CardTitle,TabContent, TabPane, Nav, NavItem, NavLink,
  Card, Modal, ModalHeader, ModalBody, ModalFooter,Row,
  CardBody, Button, InputGroupAddon,CardHeader,CardFooter
} from 'reactstrap';
import classnames from 'classnames';

const UploadReport = ({ history }) => {

  const [activeStep, setActiveStep] = useState(1)
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }


  const navigateHome = () => {
    history.push('/supplier/landingpage');
  }


  const stepNext =  async (activeStep) => {
    if (activeStep + 1 == 5) {
            navigateHome();
    } else {
    
          setActiveStep(activeStep + 1);
        }
        

      
    }


  return (
    <Fragment>
    <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
    <div >

<Card>



        <CardBody>
                    <div>
                    <div class="row">
                  <div class="container">
                      <div>
                    
                      <ul class="progressbar">
                      <li style={{marginLeft: '25%'}} className={(activeStep > 1)?"processed":"active"}  >Upload File</li>
                      <li className={(activeStep > 2)?"processed": (activeStep == 2)? "active":""}  >Upload Certificates</li>
                      <li   class={(activeStep > 3)?"processed": (activeStep == 3 )? "active":""} >Review/Submit</li>
                      </ul>
                    </div>
                  </div>
                  </div>
                  </div>
                  </CardBody>
                  </Card>
      <Card>
        <CardBody>
                  <div class="row" style={{maxHeight:'calc(100vh - 50px)', overflow:'scroll'}}>
                  {(activeStep == 1)?
                  <div style={{width:'98%'}}>
                                    <UploadCreate/>
                       

                     </div>
                    : null}
                  </div>

                 
      </CardBody>
     
    
      <CardFooter style={{position: 'sticky', bottom:'0', width:'98%'}}>
                          {(activeStep != 1)?
                          <Button onClick={() => setActiveStep(activeStep-1)} color="secondary" size="lg">Back</Button>
                          : null}
                         
                          {(activeStep<=2)?
                            <Button style={{ marginLeft: 'auto'}} id='stepnext' onClick={() => {  stepNext(activeStep)}} color="secondary" size="lg">{(activeStep>2)? 'Finish': 'Next'}</Button>
                         :null} </CardFooter>
      
      </Card>
    </div>


    </ReactCSSTransitionGroup>
           </Fragment>


  )




}

export default (withRouter(UploadReport))

